var selectableData = {
    addressType: ['BUSINESS', 'HOME'],
    boardCertification: ['ABA', 'AOBA', 'Not Certified'],
    boardTitle: ['ABA_ID', 'AOBA_ID'],
    businessRole: ['Business Role 1', 'Business Role 2', 'Business Role 3'],
    ABA: ['Critical Care Medicine', 'Pain Medicine', 'Hospice and Palliative Medicine', 'Sleep Medicine', 'Pediatric Anesthesiology'],
    AOBA: ['Critical Care', 'Pain Management', 'Pediatric Anesthesiology'],
    country: ['USA', 'Canada', 'Mexico', 'IND', 'ASM'],
    dutyStation: ['Duty Station 1', 'Duty Station 2'],
    emailLocation: ['Primary', 'Email2', 'Email3'],
    emailType: ['BUSINESS', 'HOME'],
   // gender: ['Male', 'Female', 'Other', 'Prefer not to answer'],
    medSchoolProgramType: ['Medical School', 'Training Program', 'Program Type 3', 'Program Type 4'],
    phoneLocation: ['CELL', 'BUSINESS'],
    rank: ['Cpt', 'Pvt'],
    solicitations: [
        {
            "Code": "AllowEmailFlag",
            "Description": "Email"
        },
        {
            "Code": "AllowPhoneFlag",
            "Description": "Phone"
        }
    ],
    directoryProfile: [
        {
            "Code": "IncludeInDirectoryFlag",
            "Description": "Include Professional Profile in Member Directory"
        }
    ],
    state: ['', 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'USSA', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'Other'],
    stateMilitary: ['USSA', 'AL', 'CO', 'IN', 'IL'],
    fellowshipCity: ['Chicago', 'Denver', 'Indianapolis', 'Birmingham'],
    yesNo: [{ label: 'Yes', value: true }, { label: 'No', value: false }],

    // these get their data injected via selectableApiData.jsx:
    activeSubboards: [],
   // activeProgramDegrees: [],
    clinicalInterests: [],
    institutions: [],
    educationProgramType: [],
    fellowshipType: [],
    fellowshipSubtype: [],
    allEmailPreferences: [],
    ethnicity: [],
    race: [],
    gender:[],
    prefix: [],
    suffix: [],
    militaryPrefix: [],
    militaryBranch: [],
    governmentSector: [],
    credentials: [],
    countriesAndStates: [],
    countries: [],
    statesByCountry: [],
    districts: [],
    primaryPracticeLocations: []
};
module.exports = selectableData;